import React from "react"
import Header from "../components/Header"
import Footer from "../components/Footer"
import ProjectNavigation from "../components/ProjectNavigation"
import ResponsiveImage from "../components/ResponsiveImage"

// Budai Wallet Project Page
const images = [
    "/images/projects/wallet/IMG_8877",
    "/images/projects/wallet/IMG_8878",
    "/images/projects/wallet/IMG_8879", 
    "/images/projects/wallet/IMG_8882",
    "/images/projects/wallet/engraving"
]

function GlobalStyles() {
    return (
        <style>{`
            .key-designs-heading-container {
                text-align: center;
                margin: 40px 0;
            }
            .image-text-section {
                display: flex;
                align-items: center;
                gap: 40px;
                padding: 40px;
                max-width: 1200px;
                margin: 0 auto;
            }
            .image-text-section .image-container {
                width: 50%;
                aspect-ratio: 1/1;
                overflow: hidden;
                position: relative;
            }
            .moodboard-container {
                max-width: 1200px;
                margin: 60px auto;
                padding: 0 20px;
            }
            .moodboard-container h2 {
                text-align: center;
                margin-bottom: 30px;
            }
            @media (max-width: 768px) {
                .image-text-section {
                    flex-direction: column !important;
                    padding: 20px;
                    gap: 20px;
                }
                .image-text-section .image-container,
                .image-text-section .text-content {
                    width: 100%;
                }
            }
        `}</style>
    )
}

function ImageTextSection() {
    return (
        <section className="image-text-section">
            <div className="image-container">
                <ResponsiveImage 
                    src={`${images[0]}.webp`}
                    alt="Budai Wallet design 1"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    priority={true}
                    loading="eager"
                    sizes="(max-width: 768px) 100vw, 50vw"
                />
            </div>
            <div className="text-content">
                <h2>Final Wallet Photo 1</h2>
            </div>
        </section>
    )
}

function ImageTextSectionReversed() {
    return (
        <section className="image-text-section" style={{ flexDirection: 'row-reverse' }}>
            <div className="image-container">
                <ResponsiveImage 
                    src={`${images[1]}.webp`}
                    alt="Budai Wallet design 2"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    priority={true}
                    loading="eager"
                    sizes="(max-width: 768px) 100vw, 50vw"
                />
            </div>
            <div className="text-content">
                <h2>Final Wallet Photo 2</h2>
            </div>
        </section>
    )
}

function ImageTextSectionThree() {
    return (
        <section className="image-text-section">
            <div className="image-container">
                <ResponsiveImage 
                    src={`${images[2]}.webp`}
                    alt="Budai Wallet design 3"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    loading="lazy"
                    priority={false}
                    sizes="(max-width: 768px) 100vw, 50vw"
                />
            </div>
            <div className="text-content">
                <h2>Final Wallet Photo 3</h2>
            </div>
        </section>
    )
}

function ImageTextSectionFour() {
    return (
        <section className="image-text-section" style={{ flexDirection: 'row-reverse' }}>
            <div className="image-container">
                <ResponsiveImage 
                    src={`${images[3]}.webp`}
                    alt="Budai Wallet design 4"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    loading="lazy"
                    priority={false}
                    sizes="(max-width: 768px) 100vw, 50vw"
                />
            </div>
            <div className="text-content">
                <h2>Final Wallet Photo 4</h2>
            </div>
        </section>
    )
}

function ImageTextSectionFive() {
    return (
        <section className="image-text-section">
            <div className="image-container">
                <ResponsiveImage 
                    src={`${images[4]}.webp`}
                    alt="Budai Wallet SVG engraving"
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover"
                    }}
                    loading="lazy"
                    priority={false}
                    sizes="(max-width: 768px) 100vw, 50vw"
                />
            </div>
            <div className="text-content">
                <h2>SVG Engraving</h2>
            </div>
        </section>
    )
}

function BudaiWallet() {
    return (
        <div>
            <GlobalStyles />
            <Header />
            
            <ProjectNavigation currentProject="/budai-wallet" />
            
            <div className="key-designs-heading-container">
                <h1>Budai Wallet</h1>
                <div style={{ 
                    maxWidth: "800px", 
                    margin: "20px auto 40px",
                    lineHeight: "1.6",
                    fontSize: "16px",
                    color: "#333",
                    padding: "0 20px"
                }}>
                    <p>
                        My "Budai" Wallet was inspired by the Eastern approach to Zen Buddhism. A famous monk, Budai, often referred to as the laughing Buddha, is engraved on the left inner pocket of the wallet. The design evokes a misty and sandy Chinese teahouse on a mountain, with the black engraving and stitching representing the ash of lit candles and black sand in zen gardens.
                    </p>
                    <p style={{ marginTop: "15px" }}>
                        The green leather serves a dual purpose: symbolizing the rolling green hills of Huangshan, where Buddhist monasteries and temples have long stood, and representing the sacred Chinese jade stone. The laughing Buddha represents the idea of tranquil contentedness with the ever-flowing nature of life, all tied together by the engraved quote "青山元不动，白云自去来" (Fisherman's Song) by a Five Dynasties / early Song Chan Buddhist monk nicknamed "狮公" (Lion Master).
                    </p>
                    <p style={{ marginTop: "15px" }}>
                        This roughly translates to "The green mountains, from the beginning, do not move; The white clouds, of themselves, come and go" or "Green hills stand unmoving; white clouds wander freely." The mountain symbolizes our ideal nature or mindset as people according to Zen Buddhism, stable and unmoved, while the clouds symbolize transient thoughts or external events. In Zen context: one's mind remains "immovable" even as things outside of our control "come and go."
                    </p>
                </div>
            </div>
            
            <ImageTextSection />
            <ImageTextSectionReversed />
            <ImageTextSectionThree />
            <ImageTextSectionFour />
            <ImageTextSectionFive />
            
            <div className="moodboard-container">
                <h2 style={{ textAlign: 'center', marginBottom: '30px' }}>Design Inspiration</h2>
                <ResponsiveImage 
                    src="/images/projects/wallet/WalletMoodboard.webp"
                    alt="Budai Wallet moodboard"
                    style={{ width: "100%", height: "auto", display: "block", borderRadius: "8px" }}
                    loading="lazy"
                    priority={false}
                    sizes="(max-width: 1200px) 100vw, 1200px"
                />
                
                <div style={{ marginTop: '30px', fontSize: '14px', color: '#666' }}>
                    <h3 style={{ marginBottom: '15px', color: '#333' }}>Image Attributions:</h3>
                    <ol style={{ paddingLeft: '20px', lineHeight: '1.8', textAlign: 'left' }}>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Meier, P. (n.d.). <em>White drifting smoke</em>. Unsplash. https://unsplash.com/photos/white-smoke-1uVCTVSn-2o
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            McKinnell, A. (2017, February 28). <em>Huangshan (Yellow Mountains), China – Part 1</em>. Anne McKinnell Photography. https://annemckinnell.com/2017/02/28/huangshan-yellow-mountains-china-part-1/
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Jiménez, J. (n.d.). <em>Image of Taimu Mountain Temple, located in Ningde, Fujian Province, China</em>. Pinterest. https://www.pinterest.com/pin/1055599907892775/
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Xu, Z. (n.d.). <em>Render of Jade Chinese mythological dragon statue</em> [3D artwork]. ArtStation. https://www.artstation.com/artwork/9eRPQN
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            TheStockWarehouse. (2014, May 23). <em>Cloud PNG showing white fluffy cloud formation</em> [Digital image]. DeviantArt. https://www.deviantart.com/thestockwarehouse/art/Cloud-PNG-Version-2-455137364
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            FreeIconsPNG. (n.d.). <em>Thin cloud icon transparent background</em> [Image]. https://www.freeiconspng.com/img/34472
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Museum of Chinese in America. (n.d.). <em>Laughing Buddha sculpture showing traditional smiling Budai figure</em>. https://www.mocanyc.org/collections/stories/laughing-buddha-sculpture/
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            DeLeon, J. [@jiandeleon]. (2024, May). <em>Image of Jian DeLeon wearing green leather jacket</em> [Instagram photo]. Instagram. https://www.instagram.com/jiandeleon/p/C_tDgxePLP2/?img_index=3
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Leatherology. (n.d.). <em>Thin bifold wallet in brown leather showcasing pattern inspiration</em> [Product image]. https://www.leatherology.com/media/webImg/Thin-Bifold-Wallet-Brown-115-516_fullsize.jpg?width=780
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Bottega Veneta. (n.d.). <em>Woven green wallet with intricate leather intrecciato pattern</em> – Product photo. Net-a-Porter. https://www.net-a-porter.com/variants/images/1647597304970092/in/w2000_q60.jpg
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Yoogi's Closet. (n.d.). <em>Bottega Veneta woven green leather small cassette bag</em>. eBay. https://backend.yoogiscloset.com/media/catalog/product/5/9/597461_01.jpg
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Hellen. (n.d.). <em>Circular brushed black sand in a zen garden with a centered yin-yang</em> [Image]. Pinterest. https://www.pinterest.com/pin/19632948378047038/
                        </li>
                        <li style={{ paddingLeft: '20px', textIndent: '-20px', marginBottom: '10px' }}>
                            Retro-ology. (n.d.). <em>Vintage Avirex green leather jacket image from eBay</em>. eBay. https://i.ebayimg.com/images/g/~PIAAOSwMHRm~rgx/s-l1600.webp
                        </li>
                    </ol>
                </div>
            </div>
            
            <Footer />
        </div>
    )
}

export default BudaiWallet